define('helperMisc',['require','helperMisc-cloneObject','helperMisc-formatTime','helperMisc-replaceTextholder','helperMisc-validate'],function(require) {
    'use strict';

    var Misc = {
        cloneObject: require('helperMisc-cloneObject'),
        formatTime: require('helperMisc-formatTime'),
        replaceTextholder: require('helperMisc-replaceTextholder'),
        validate: require('helperMisc-validate')
    };

    return Misc;

});

